export default {"src":"/_next/static/media/bg.ed7bc63f.svg","height":112,"width":112,"blurWidth":0,"blurHeight":0};